module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"d9d57855961bdd4a41017fda7d2b8113"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
